import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectArchivalChangeFailedAction = {
	type: 'SUBJECT_ARCHIVAL_CHANGE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectArchivalChangeFailedAction => ({
	type: 'SUBJECT_ARCHIVAL_CHANGE_FAILED',
	payload,
});
